import { ICoverageReportStoreSegment } from './coverageReport.interface';

export const coverageReportStoreSelector = (state: ICoverageReportStoreSegment) => state.coverageReport;
